import React, { useContext, useEffect, useState } from "react";
import SetupRadio from "../SharedComponents/SetupRadio";
import SetupDropDown from "../SharedComponents/SetupDropdown";
import SubmitBtn from "../SharedComponents/SubmitBtn";
import SetupInput from "../SharedComponents/SetupInput";
import SetupContainer from "../SharedComponents/SetupContainer";
import SetupTittle from "../SharedComponents/SetupTittle";
import Box from "../SharedComponents/Box";
import axios from "axios";
import HistoryTable from "../SharedComponents/HistoryTable";
import Swal from "sweetalert2";
import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";

const DeliveryPlanSetup = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  useEffect(() => {
    axios
      .get(`${backendUrl}DeliveryPlan`)
      .then((res) => setFetchedData(res.data))
      .catch((err) => console.log(err.message));
  }, [backendUrl, refetch]);

  const initialValue = {
    id: 0,
    name: "",
    minDays: "",
    maxDays: "",
    routeId: "",
    sortOrder: 0,
    isActive: "",
    creatorId: GetLocalStorageUserId(),
    creationDate: new Date(),
    modifierId: GetLocalStorageUserId(),
    modificationDate: new Date(),
  };

  const [formData, setFormData] = useState(initialValue);
  const [willUpdate, setWillUpdate] = useState(false);

  const update = (data) => {
    setFormData({ ...formData, ...data });
  };
  const { handleDataReload } = useContext(contextProvider);
  const formHandle = (e) => {
    e.preventDefault();
    const minDays = parseInt(formData.minDays, 10);
    const maxDays = parseInt(formData.maxDays || formData.minDays, 10);
    if (!(minDays > 0) || !(maxDays > 0)) {
      Swal.fire({
        title: "Enter a delivery day range (from and to).",
        icon: "warning",
      });
      return;
    }
    if (maxDays < minDays) {
      Swal.fire({
        title: "To days cannot be less than from days.",
        icon: "warning",
      });
      return;
    }
    const payload = { ...formData, minDays, maxDays, days: minDays };

    if (!willUpdate) {
      axios
        .post(`${backendUrl}DeliveryPlan`, payload)
        .then((res) => {
          if (res.status === 201) {
            Swal.fire({
              title: `Delivery Plan Created Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) =>
          Swal.fire({
            title:
              err?.response?.data ||
              err?.message ||
              "Failed to create delivery plan",
            icon: "error",
          }),
        );
    }

    if (willUpdate) {
      axios
        .put(`${backendUrl}DeliveryPlan/${formData.id}`, payload)
        .then((res) => {
          if (res.status === 204) {
            Swal.fire({
              title: `Delivery Plan Updated Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) =>
          Swal.fire({
            title:
              err?.response?.data ||
              err?.message ||
              "Failed to update delivery plan",
            icon: "error",
          }),
        );
    }
  };

  return (
    <div>
      <Box top>
        <SetupTittle text="Delivery Plan" />
        <SetupContainer>
          <form className="" onSubmit={formHandle}>
            <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
              <SetupInput
                name="name"
                type="text"
                placeHolder="Plan name"
                allTimeValue={formData.name}
                valueUpdate={(e) => update({ name: e.target.value })}
              />
              <SetupInput
                name="minDays"
                type="number"
                placeHolder="Delivery days (from)"
                allTimeValue={formData.minDays}
                valueUpdate={(e) =>
                  update({
                    minDays:
                      e.target.value === "" ? "" : parseInt(e.target.value, 10),
                  })
                }
              />
              <SetupInput
                name="maxDays"
                type="number"
                placeHolder="Delivery days (to)"
                allTimeValue={formData.maxDays}
                valueUpdate={(e) =>
                  update({
                    maxDays:
                      e.target.value === "" ? "" : parseInt(e.target.value, 10),
                  })
                }
              />
              <SetupDropDown
                dataOf="route"
                allTimeValue={formData.routeId}
                valueUpdate={(e) =>
                  update({ routeId: parseInt(e.target.value, 10) })
                }
                placeHolder="Route name"
                name="routeId"
              />
              <SetupInput
                name="sortOrder"
                type="number"
                placeHolder="Sort order"
                allTimeValue={formData.sortOrder}
                valueUpdate={(e) =>
                  update({
                    sortOrder:
                      e.target.value === "" ? 0 : parseInt(e.target.value, 10),
                  })
                }
              />
              <SetupRadio
                name="isActive"
                placeHolder="Plan status?"
                allTimeValue={formData.isActive}
                valueUpdate={(data) => update({ isActive: data })}
              />
            </div>
            <p className="text-sm text-stone-500 mt-3">
              Use the same number in both day fields for a fixed count, or a
              range such as 15 to 20.
            </p>

            <SubmitBtn text={willUpdate ? "Update" : "Create"} />
            <SubmitBtn
              onClick={() => {
                setWillUpdate(false);
                update(initialValue);
              }}
              styleClass={!willUpdate && "hidden"}
              text="Cancel"
            />
          </form>
        </SetupContainer>
      </Box>
      <Box>
        <SetupTittle text="History" />
        <SetupContainer>
          <HistoryTable
            editCallBack={(data) => {
              update({
                ...data,
                minDays: data.minDays || data.days || "",
                maxDays: data.maxDays || data.minDays || data.days || "",
              });
              setWillUpdate(true);
            }}
            fetchedData={fetchedData}
            headers={["Plan name", "Days", "Route", "Sort order", "Status"]}
            row={["name", "daysLabel", "routeName", "sortOrder", "isActive"]}
            extraFields={["routeId", "minDays", "maxDays"]}
          />
        </SetupContainer>
      </Box>
    </div>
  );
};

export default DeliveryPlanSetup;
